export enum PhItemLinesInspectionStatusEnum{
    OPEN ='OPEN',
    INPROGRESS ='INPROGRESS',
    COMPLETE ='COMPLETE',
}